import { Breadcrumb, Table } from "antd";
import * as React from "react";
import styled from "styled-components";
import PageHeader from "../comp/pageheader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getGroupDateMeeting } from "../api/api";
import { AnyType } from "../util/types";

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const Detail: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const timerRef = React.useRef<any>(0);

  const [alist, setAlist] = React.useState([]);
  const [qlist, setQlist] = React.useState([]);

  const [querys] = useSearchParams();
  const groupId = querys.getAll("id")[0] || "";
  const createTimeStr = querys.getAll("name")[0] || "";

  const [total, setTotal] = React.useState(0);
  const [pageno, setpageno] = React.useState(1);

  const [agroup, setAgroup] = React.useState<AnyType>({});

  const getMettings = async () => {
    const ret = await getGroupDateMeeting(groupId, createTimeStr);
    const { idAndUserList, likeSubjects, questions, answerAllLists, group } =
      ret ?? {};

    setAgroup(group ?? {});

    const users = {} as any;
    (idAndUserList ?? []).forEach((x: any) => (users[x.id] = x));
    const ques = {} as any;
    (questions ?? []).forEach((x: any) => (ques[x.userId] = x.title));
    const aret = (likeSubjects ?? []).map((x: any) => ({
      ...x,
      ...users[x.userId],
      title: ques[x.userId],
    }));
    setAlist(aret);

    /////
    const anss = {} as any;
    (answerAllLists ?? []).forEach((x: any) => {
      x.userName = users[x.userId].nickName;
      if (anss[x.questionId]) {
        anss[x.questionId].push(x);
      } else {
        anss[x.questionId] = [x];
      }
    });

    const bret = (questions ?? []).map((x: any) => ({
      ...x,
      answers: anss[x.id],
    }));

    setQlist(bret);
  };

  React.useEffect(() => {
    getMettings();
  }, [pageno]);

  const colunmns = [
    { title: "同修伙伴", dataIndex: "nickName", width: "5%" },
    {
      title: "本周自我评价",
      children: [
        {
          title: "健康",
          dataIndex: "aa",
          render: (_: string, x: any) => x.weeklyMarks.split(",")[0],
          width: "1%",
        },
        {
          title: "情绪",
          dataIndex: "aa",
          render: (_: string, x: any) => x.weeklyMarks.split(",")[1],
          width: "1%",
        },
        {
          title: "生活",
          dataIndex: "aa",
          render: (_: string, x: any) => x.weeklyMarks.split(",")[2],
          width: "1%",
        },
        {
          title: "工作",
          dataIndex: "aa",
          render: (_: string, x: any) => x.weeklyMarks.split(",")[3],
          width: "1%",
        },
      ],
    },
    { title: "对自己印象最深的打卡内容", dataIndex: "mySelfLike" },
    // {
    //   title: "对他人印象最深的打卡内容",
    //   children: [
    //     { title: "1", dataIndex: "likeOthersOne" },
    //     { title: "2", dataIndex: "likeOthersTwo" },
    //     { title: "3", dataIndex: "likeOthersThree" },
    //   ],
    // },
    { title: "讨论区：请你提出一个问题", dataIndex: "title" },
  ];

  const colums2 = [
    { title: "提问", dataIndex: "title", width: "20%" },
    {
      title: "票数",
      dataIndex: "title",
      render: (_: string, record: any) => record.totleVoteNum + "票",
      width: "4%",
    },
    {
      title: "回复",
      dataIndex: "title",
      render: (_: string, record: any) => (
        <>
          {(record.answers || []).map((x: any) => (
            <div key={x.id}>
              {x.userName}：{x.content}
            </div>
          ))}
        </>
      ),
    },
  ];

  //

  const expandedRowRender = (record: any) => {
    const ds = [
      { index: 1, txt: record.likeOthersOne },
      { index: 2, txt: record.likeOthersTwo },
      { index: 3, txt: record.likeOthersThree },
    ];
    const columns = [
      { title: "序号", dataIndex: "index", key: "index" },
      { title: "对他人印象最深的打卡内容", dataIndex: "txt", key: "txt" },
    ];
    return (
      <Table
        columns={columns}
        dataSource={ds}
        pagination={false}
        bordered
        size="small"
      />
    );
  };

  React.useEffect(() => {
    timerRef.current! = setInterval(() => {
      getMettings();
    }, 5000);
    return () => {
      clearInterval(timerRef.current!);
      timerRef.current = null;
    };
  }, []);

  return (
    <Container>
      <div className="rightcontent">
        <div className="breadCrmb">
          <Breadcrumb>
            <Breadcrumb.Item>
              <span className="p" onClick={() => navigate("/group")}>
                首页
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {agroup.name} {createTimeStr} 周会
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <Table
          dataSource={alist}
          columns={colunmns}
          rowKey={(x) => `${x.userId}`}
          pagination={false}
          bordered
          expandable={{
            expandedRowRender,
            defaultExpandAllRows: true,
          }}
        />
      </div>
      <div className="content mt30">
        <Table
          dataSource={qlist}
          columns={colums2}
          rowKey={(x) => `${x.id}+${Math.random()}`}
          pagination={false}
          bordered
        />
      </div>
    </Container>
  );
};

export default Detail;
